import React, { useState } from 'react'
import { Flex, Switch, Typography } from 'antd'
import { CButton } from '@coreui/react-pro'
import { useUnit } from 'effector-react'
import { WalletCard } from '../../../../views/widgets/walletCard'
import { CreateWalletModal } from '../atoms/CreateWalletModal'
import { useWalletsList } from './hooks'
import { InProcessCard } from '../../../../views/widgets/inProcessCard'
import { WalletsTable } from '../walletsTable'
import { InProcessTable } from '../inProcessTable'
import { WalletsSummary } from '../atoms/WalletsSummary'
import { $isTableView, setTableView } from './model'
import { walletsListMounted } from './model'

export const WalletsList = () => {
  const { wallets, inProcess } = useWalletsList()
  const [isTableView, setIsTableView] = useUnit([$isTableView, setTableView])

  const [isModalOpen, setIsModalOpen] = useState(false)

  const showModal = () => {
    setIsModalOpen(true)
  }

  return (
    <div className="d-flex flex-column" style={{ gap: 32 }}>
      <Flex justify="space-between" align="center">
        <Flex align="center" gap="middle">
          <Typography.Title
            level={1}
            className="text-dark"
            style={{ margin: 0 }}
          >
            Wallets
          </Typography.Title>
          <Switch
            checked={isTableView}
            onChange={setIsTableView}
            checkedChildren="Table"
            unCheckedChildren="Cards"
          />
        </Flex>
        <CButton color="primary" size="sm" onClick={showModal}>
          + Add new wallet
        </CButton>
      </Flex>
      <WalletsSummary />
      {isTableView ? (
        <>
          <InProcessTable />
          <WalletsTable />
        </>
      ) : (
        <>
          <InProcessCard data={inProcess} />
          <Flex wrap="wrap" gap={24}>
            {wallets?.map((item) => (
              <WalletCard data={item} key={item.id} />
            ))}
          </Flex>
        </>
      )}
      <CreateWalletModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onCreated={() => walletsListMounted()}
      />
    </div>
  )
}
